import { messageStop } from "@/api/llm";
import { useTimeoutFn } from "@/utils/chat/index";
import React, { useContext, useEffect, useState } from "react";
import styles from "./index.module.less";
import { connect } from "dva";
import { LLMMessageStatus } from "@/types/chat/State";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";

// 问题操作区
function QuestionOperation(props: any) {
  const {
    message,
    selectedSession,
    updateSessionMessageMid,
    className = "",
    dealStopQuestions,
    llmQuestionInfo,
    connectState
  } = props;
  const [wrapStyle, setWrapStyle] = useState({});
  const elWrap = document.getElementById("message-box-container-scroll");
  const [stopping, setStopping] = useState<boolean>(false);

  const updateStyle = (message: any) => {
    if (!elWrap) {
      return;
    }
    if (className) {
      setWrapStyle({
        display: "flex"
      });
      return;
    }
    const el = document.getElementById(`id-${message.id}`);
    if (!el) {
      return;
    }
    const elsub = el.querySelector(".content-container-202");
    if (!elsub) {
      return;
    }
    const r = elWrap.getBoundingClientRect().right - elsub.getBoundingClientRect().right - 10;
    const b = 12;
    setWrapStyle({
      bottom: b,
      right: r,
      display: "flex"
    });
  };

  const [isReady] = useTimeoutFn(() => {}, 3000);

  useEffect(() => {
    if (isReady()) {
      updateStyle(message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, message]);

  const doHandleOffline = () => {
    if (message?.id && message.flag !== LLMMessageStatus.END) {
      updateSessionMessageMid({
        sessionId: selectedSession.sessionId,
        sendResult: {
          body: { ...message, flag: LLMMessageStatus.END }
        }
      });
    }
  }

  useEffect(() => {
    if (connectState.state !== ConnectState.READY) {
      doHandleOffline();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectState?.state]);

  const handleStop = () => {
    // if (message?.id) {
    //   updateSessionMessageMid({
    //     sessionId: selectedSession.sessionId,
    //     sendResult: {
    //       body: { ...message, flag: "end" }
    //     }
    //   });
    // }
    setStopping(true);
    dealStopQuestions({
      id: message?.id || ""
    });
    // messageStop({
    //   requestId: message.id
    // }).then((res) => {});
  };
  return (
    <div className={`${styles[className]} ${styles["operation-wrap"]}`} style={wrapStyle}>
      <div className={styles["item"]} onClick={handleStop}>
        {stopping ? "正在停止" : "停止生成"}
      </div>
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    llmQuestionInfo: chat.llmQuestionInfo,
    connectState: chat.connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    dealStopQuestions(data: any) {
      dispatch({ type: "chat/dealStopQuestions", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(QuestionOperation);
